import {
  PatientAlert,
  PatientAlertCreate,
  PatientAlertEdit,
  PatientAlertsQueryParams,
} from "services/types/patient-alerts.type";
import { formatValidQueryParamUrl } from "utils/common";

import { emptySplitApi } from "./empty-split-api";

export const patientAlertsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatientAlerts: builder.query<PatientAlert[], PatientAlertsQueryParams>({
      query: ({
        limit = 25,
        offset = 0,
        ordering = "-alert_date",
        query = "{id,alert_description,created_at,created_by,discarded_at,alert_date}",
        ...params
      }) =>
        `/patient-alerts/?${formatValidQueryParamUrl({
          limit,
          offset,
          ordering,
          query,
          ...params,
        })}`,
      providesTags: ["PatientAlerts"],
    }),
    getPatientAlert: builder.query<PatientAlert, { id: number }>({
      query: ({ id }) => `/patient-alerts/${id}/`,
      providesTags: ["PatientAlerts"],
    }),
    addPatientAlert: builder.mutation<PatientAlert, PatientAlertCreate>({
      query: (body) => ({
        url: `/patient-alerts/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["PatientAlerts"],
    }),
    editPatientAlert: builder.mutation<PatientAlert, PatientAlertEdit>({
      query: ({ id, ...rest }) => ({
        url: `/patient-alerts/${id}/`,
        method: "PATCH",
        body: rest,
      }),
      invalidatesTags: ["PatientAlerts"],
    }),
    discardPatientAlert: builder.mutation<any, { id: number }>({
      query: ({ id }) => ({
        url: `/patient-alerts/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["PatientAlerts"],
    }),
  }),
});

export const {
  useGetPatientAlertsQuery,
  useGetPatientAlertQuery,
  useAddPatientAlertMutation,
  useEditPatientAlertMutation,
  useDiscardPatientAlertMutation,
} = patientAlertsApi;
